import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/all";
import { ScrollTrigger } from "gsap/all";

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

  let smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper-mywork",
    content: "#smooth-content-mywork",
    smooth: 2,
    smoothTouch: 0.1,
  });
});

// const myWorkBox = document.querySelectorAll(".section-mywork__box");
// let lastScrollY = window.scrollY;

// window.addEventListener("scroll", function (e) {
//   const CurrentScrollY = window.scrollY;

//   if (CurrentScrollY > lastScrollY) {
//     console.log("Scrolling Down");
//     myWorkBox.forEach((box) => {
//       box.style.transform = `skewY(-2deg)`;
//       box.style.transition = `transform 0.5s ease`;
//     });
//   } else {
//     console.log("Scrolling Up");
//     myWorkBox.forEach((box) => {
//       box.style.transform = `skewY(2deg)`;
//       box.style.transition = `transform 0.5s ease`;
//     });
//   }

//   lastScrollY = CurrentScrollY;
// });

// window.addEventListener("scrollend", function () {
//   myWorkBox.forEach((box) => {
//     box.style.transform = `skewY(0deg)`;
//     box.style.transition = `transform 0.5s ease`;
//   });
// });
